/* eslint-disable jsx-a11y/label-has-associated-control */
import Skeleton from '@root/components/Skeleton';
import ServiceListResourceSkeleton from '@root/components/Ui/ServiceListResourceSkeleton';
import { PageComponent } from '@root/pages/Type';
import styles from './Item.module.scss';

type ItemSkeletonProps = {
    index: string;
};

const ItemSkeleton: PageComponent<ItemSkeletonProps> = ({ index }) => {
    return (
        <div className={styles.service_item}>
            <div className={styles.base}>
                {false && (
                    <div className="checkbox">
                        <div className="form-group">
                            <div className="form-check">
                                <input
                                    className="form-check-input"
                                    type="checkbox"
                                    id="profileNewsletters"
                                />
                                <label
                                    className="form-check-label"
                                    htmlFor="profileNewsletters"
                                />
                            </div>
                        </div>
                    </div>
                )}
                <div className={styles.logo}>
                    <Skeleton width={127} height={127} />
                </div>
                <div className={styles.info}>
                    <h1>
                        <Skeleton width={345} />
                    </h1>
                    <h2>
                        <Skeleton width={45} />
                    </h2>
                    <h3>
                        <i className="icon-dot" />
                        <Skeleton width={88} />
                    </h3>
                </div>
                <div className={styles.expire}>
                    <Skeleton width={166} />
                </div>
                <div className={styles.control}>
                    <Skeleton width={242} height={56} />
                    <Skeleton width={63} height={56} />
                </div>
            </div>
            <div className={styles.resources}>
                {Array(7).fill(0).map((_, resource) => {
                    return (
                        <ServiceListResourceSkeleton
                            key={`list-service-${index}-resource-${resource}`}
                        />
                    );
                })}
            </div>

            <div className={styles.base}>
                <div className={styles.expire}>
                    <Skeleton />
                </div>
                <div className={styles.control}>
                    <Skeleton />
                    <Skeleton />
                </div>
            </div>
        </div>
    );
};

export default ItemSkeleton;
